import React from 'react'
import PicklistField from 'core/components/validatedForm/DropdownField'

const additionalInfo =
  'Select an AWS SSH key to be associated with the nodes. This key can be used to access the nodes for debugging or other purposes.'

export default ({
  dropdownComponent,
  values,
  required = true,
  wizardContext,
  setWizardContext,
  info = additionalInfo,
}) => {
  return (
    <PicklistField
      DropdownComponent={dropdownComponent}
      disabled={!(wizardContext.cloudProviderId && wizardContext.region)}
      id="sshKey"
      label="SSH Key"
      cloudProviderId={wizardContext.cloudProviderId}
      cloudProviderRegionId={values.region}
      tooltip={info}
      value={wizardContext.sshKey}
      onChange={(value) => setWizardContext({ sshKey: value })}
      required={required}
      enableSearch
    />
  )
}
